define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/action/Controller",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/enums",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType"
], function(array,declare,lang,Memory,csi,Controller,AddPath,Relationship,enums,FormWidget,html,locale,csi_store,Names,ActionControllerMixin,xml,Query,
			ProductType) {

	var	FIELD_RETAIN = "ReplaceFixedMaterialRetain";

	return declare(FormWidget, {
		_storeMaterial: null,

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: get store for "to" materials
			var	psPlacement = this.getViewNode();
			var query = new Query().RefAttr("ProductType", xml.OP_EQUALS, psPlacement.MaterialType);
			if (psPlacement.FixedMaterial != csi.EMPTY_URL) {
				query.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, psPlacement.FixedMaterial);
			}
			return this._storeMaterial = this._storeMaterial || this._getStore(lang.mixin(new Relationship(), {
				m_typeNode: "Material",
				m_query: query
			}));
		},

		_getStore: function(/*Relationship*/r) {
			// summary: get store given relationship
			var	storeOptions = {data: [csi_store.nameObject("")]};
			csi_store.namesOptionsByRelationship(this.getContext(), r, storeOptions);
			return new Names(storeOptions);
		},

		_resolveView: function() {
			// summary: set default values
			var	psPlacement = this.getViewNode();
			var productStructure = this.cacheView.getNode(psPlacement.__Parent__, true);
			if (psPlacement.$URL == productStructure.Placements[0]) {
				this.addFixedValue(FIELD_RETAIN, false);
			} else {
				this.addDefaultValue(FIELD_RETAIN, true);
			}
			this.inherited(arguments);
		}
	});
});
